"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResourceList = void 0;
const app_1 = require("@koopajs/app");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const useResourceList = (props) => {
    const { path, searchParams = {}, useCache = false, setSearchParams } = props;
    const dispatch = react_redux_1.useDispatch();
    const activeWorkspaceId = react_redux_1.useSelector(app_1.Selectors.Workspaces.getActiveWorkspaceId);
    const { errorMessage, isProcessing, metadata } = react_redux_1.useSelector(app_1.Selectors.Entities.state(path));
    const resources = react_redux_1.useSelector(app_1.Selectors.Entities.getItems(path));
    const entitiesFetchOperation = app_1.Operations.Entities.fetch(dispatch);
    const entitiesCreateOperation = app_1.Operations.Entities.save(dispatch);
    const facets = metadata.facets || undefined;
    const totalCount = metadata.totalCount || undefined;
    react_1.useEffect(() => {
        const core = async () => {
            await entitiesFetchOperation(activeWorkspaceId, path, searchParams);
        };
        if (!useCache) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            core();
        }
    }, [
        path,
        useCache,
        activeWorkspaceId,
        searchParams.page,
        searchParams.query,
        searchParams.size,
        searchParams.sort,
        searchParams.filters
    ]);
    const setQuery = (query) => {
        setSearchParams(Object.assign(Object.assign({}, searchParams), { page: undefined, query }));
    };
    const setPage = (page) => {
        setSearchParams(Object.assign(Object.assign({}, searchParams), { page: page - 1 }));
    };
    const createResource = async (resource) => {
        return await entitiesCreateOperation(activeWorkspaceId, path, resource);
    };
    return {
        errorMessage,
        isProcessing,
        resources,
        facets,
        totalCount,
        searchParams,
        createResource,
        setQuery,
        setPage
    };
};
exports.useResourceList = useResourceList;
//# sourceMappingURL=useResourceList.js.map